import DreamcaseGrid from "@/components/common/DreamcaseGrid";
import BaseSeo from "@/components/seo/BaseSeo";
import { Grid, Typography } from "@mui/material";
import { IStaticPage } from "interfaces/api_interfaces";
import {
  GetStaticPaths,
  GetStaticProps,
  GetStaticPropsContext,
  InferGetStaticPropsType,
} from "next";
import { useRouter } from "next/router";
import { useLocalization } from "providers/LocalizationProvider";
import { publicApi } from "api/content-api-client";
import { REVALIDATE_TIME } from "utils/constants";
import { staticPagesPaths } from "utils/ssr/static_pages";

const StaticPage = ({
  page,
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  const router = useRouter();
  const { toLocalizedString } = useLocalization();

  const currentLanguage = router.locale?.split("-")[0];

  return (
    <>
      <BaseSeo
        title={toLocalizedString(page.seo_title)}
        description={toLocalizedString(page.seo_description)}
        image={page.seo_image}
      />
      <main>
        <DreamcaseGrid>
          <Grid item xs={12}>
            <Typography variant="h2">
              {toLocalizedString(page.title)}
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ textAlign: "justify" }}>
            {currentLanguage && (
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    currentLanguage === "sl"
                      ? page.content_sl
                      : page.content_en,
                }}
              />
            )}
          </Grid>
        </DreamcaseGrid>
      </main>
    </>
  );
};

// Get all possible SLUGs of static pages
export const getStaticPaths: GetStaticPaths = async () => {
  const paths = await staticPagesPaths();
  return {
    paths,
    fallback: "blocking",
  };
};

// Fetch static page
export const getStaticProps: GetStaticProps = async (
  context: GetStaticPropsContext
) => {
  const { params } = context;

  try {
    const { data: pageData } = await publicApi.get<IStaticPage>(
      `/static_pages/${params?.id}`
    );
    return {
      props: { page: pageData },
      revalidate: REVALIDATE_TIME,
    };
  } catch (error) {
    return { notFound: true, revalidate: REVALIDATE_TIME };
  }
};

export default StaticPage;
